module.exports = __webpack_public_path__ + "img/mcgl_xsbj_05.756127e5.png";